/**
 * Palette colori per i chart a categorie multiple (breakdown per tipo,
 * contesto, meccanismo, zona corporea…) di AthleteInjuryCharts.
 *
 * Sempre token tema (`var(--c-*)` / `var(--ri-*)`), mai hex hardcoded, così
 * la palette resta coerente fra i chart e si aggiorna da sola se cambia il
 * tema. L'unica eccezione è il ciano (nessun token dedicato — stesso hex già
 * usato per la serie sRPE/RSI nel resto del cluster).
 */
export const BREAKDOWN_PALETTE: string[] = [
  'var(--c-text-0)',
  '#5BC9E0',
  'var(--c-yellow)',
  'var(--ri-good)',
  'var(--ri-critical)',
  'var(--ri-warning)',
  'var(--c-text-3)',
];

/** Colore per indice, con wraparound se le categorie superano la palette. */
export const getPaletteColor = (index: number): string => BREAKDOWN_PALETTE[index % BREAKDOWN_PALETTE.length];
